import { render, staticRenderFns } from "./SelectTranslators.vue?vue&type=template&id=57df6bbc&scoped=true"
import script from "./SelectTranslators.vue?vue&type=script&lang=js"
export * from "./SelectTranslators.vue?vue&type=script&lang=js"
import style0 from "./SelectTranslators.vue?vue&type=style&index=0&id=57df6bbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df6bbc",
  null
  
)

export default component.exports